import QRCode from 'qrcode-generator';

// Helper function for QR code SVG (using qrcode-generator)
export const generateQRCodeSVG = (text: string, size: number): string => {
  const qr = QRCode(0, 'L');
  qr.addData(text);
  qr.make();
  const cellSize = size / qr.getModuleCount();
  return qr.createSvgTag({ cellSize, margin: 0 });
};

export const sanitizeNamePart = (s: string): string => s.replace(/[^a-zA-Z0-9]+/g, '');

export const emailFromName = (givenNames: string, surname: string): string => {
  let firstName = givenNames;
  if (givenNames.split(' ').length > 1) {
    firstName = givenNames.split(' ')[0];
  }
  const first = sanitizeNamePart(firstName).toLowerCase();
  const last = sanitizeNamePart(surname).toLowerCase();
  return `${first}.${last}@branhamuniversity.edu`;
};

/** crsCredentialId from IaaS offer payload (camelCase or snake_case). */
export function extractCrsCredentialId(data: unknown): string | null {
  if (!data || typeof data !== 'object') return null;
  const d = data as Record<string, unknown>;
  const raw = d.crsCredentialId ?? d.crs_credential_id ?? d.credentialId;
  return typeof raw === 'string' && raw.trim() !== '' ? raw.trim() : null;
}

export const toTitleCaseSingle = (s: string): string => {
  let name = s;
  if (name.split(' ').length > 1) {
    name = s.split(' ')[0];
  }
  return name ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() : '';
};
